function numberOfDocuments(documents) {
  let count = 0;
  Object.keys(documents).forEach((key) => {
    const validDocs = documents[key].filter(
      (doc) => doc && doc.id !== null && doc.name !== null
    );
    count += validDocs.length;
  });
  return count;
}

export default numberOfDocuments;
